<template>
	<div style="padding:2px;background-color: #f4f5f6;">
		<div style=" margin:auto">
			<div style="background-color: #fff;">
				<el-form style="display: flex;align-items: center;justify-content: center;padding-top: 22px;"
					:inline="true" :model="formInline" class="demo-form-inline">
					<el-form-item>
						<el-select v-model="formInline.gs" placeholder="归属">
							<el-option label="国标" value="国标"></el-option>
							<el-option label="宝钢" value="宝钢"></el-option>
							<el-option label="鞍钢" value="鞍钢"></el-option>
							<el-option label="攀钢" value="攀钢"></el-option>
							<el-option label="攀钢(西昌)" value="攀钢(西昌)"></el-option>
						</el-select>
						<el-button slot="append" icon="el-icon-search"></el-button>
					</el-form-item>
					<el-form-item>
						<el-input placeholder="请输入标准号或标准名称" style="width:660px" v-model="formInline.kwd"
							clearable></el-input>
					</el-form-item>
					<el-form-item>
						<el-button type="primary" @click="searchData()">查询</el-button>
						<el-button @click="resetSearch">重置</el-button>
					</el-form-item>
				</el-form>
			</div>

			<div style="">
				<el-container>
					<el-main>
						<div class="doc_header_mod">
							<div style="text-align: left;">
								<img class="pdfLogo" src="../../assets/pdfLogo.png">{{curPdf.bzm}}
							</div>
							<div style="text-align: left;margin-top: 5px;font-size: 15px;">
								标准号:{{curPdf.bzh}}
							</div>
							<div class="title-box">
								<span class="title-item">{{curPdf.gs}}</span>
								<span class="title-item">{{curPdf.state}}</span>
								<span class="title-item">{{curPdf.look}}浏览</span>
								<span class="title-item">发布日期:{{curPdf.publishTime}}</span>
								<span class="title-item">实施日期:{{curPdf.implementTime}}</span>
								<span class="title-item">上传时间:{{curPdf.uploadTime}}</span>
							</div>

						</div>
						<iframe :src="pdfPrev+curPdf.file" width="100%" height="900"></iframe>
					</el-main>
					<el-aside width="330px" style="padding: 20px">
						<div class="right-box">
							<div class="right-item" style="font-weight: bold;font-size: 17px;margin-top: 5px;">
								相关文档<span style="color: #999;font-size: 12px;margin-left: 10px;">共{{total}}篇</span>
							</div>
							<div class="right-are">
								<div class="right-item" v-for="(item,index) in tableData3" :key="index">
									<div class="bzm" :class="{'bzm-active':curPdf.id == item.id}" @click="showPDF(item)"
										style="display: flex;align-items: center;white-space: break-spaces;">
										<img class="pdfLogo" src="../../assets/pdfLogo.png">{{item.bzm}}
									</div>
									<div style="margin-top: 5px;color: #999;font-size: 12px;">
										<span>{{item.look}}浏览</span>
										<span style="margin-left:10px">{{item.gs}}</span>
										<span style="margin-left:10px">发布日期:{{item.publishTime}}</span>
									</div>
								</div>
							</div>

							<el-pagination small style="width: 100%;position: absolute;bottom: 0;"
								@size-change="handleSizeChange" @current-change="handleCurrentChange"
								:current-page="currentPage4" :page-sizes="pageSizes" :page-size="pageSize"
								layout="prev, pager, next" :total="total">
							</el-pagination>
						</div>
					</el-aside>
				</el-container>
			</div>

		</div>
		<div
			style="width:100%;margin-top: 10px; background-color: #efefef;text-align: center; height: 50px;line-height: 50px;border-top: 1px solid #ccc; margin-bottom: 2px;">
			2022 重庆市离离科技有限公司 备案 渝ICP备2020011628号-1
		</div>
	</div>
</template>

<script>
	import videourl from '../../assets/Steel/炼钢视频.mp4';
	import {
		getList_api_pdfInstruction,
		look_api_pdfInstruction
	} from "@/apiOld/pdfInstruction.js";
	export default {
		data() {
			return {
				url: videourl,
				tableData: [{
						xm: '强度',
						zd: '公制',
						dw: 'MPa',
						hsgs: '1 KSI = 7 MPa'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'KSI',
						hsgs: '1 KSI = 7 MPa'
					},
					{
						xm: '强度',
						zd: '公制',
						dw: 'mm',
						hsgs: '1 in = 25.4 mm'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'in',
						hsgs: '1 in = 25.4 mm'
					},
					{
						xm: '强度',
						zd: '公制',
						dw: 'm',
						hsgs: '1 ft = 0.30 m'
					},
					{
						xm: '强度',
						zd: '英制',
						dw: 'ft',
						hsgs: '1 ft = 12 in'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'kg',
						hsgs: '1 pound = 0.45 kg'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'pound',
						hsgs: '1 pound = 0.45 kg'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'g',
						hsgs: '1 oz = 28.35 g'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'oz',
						hsgs: '1 oz = 28.35 g'
					},
					{
						xm: '重量',
						zd: '公制',
						dw: 'g/m2',
						hsgs: '1oz/ft2=305.16g/m2'
					},
					{
						xm: '重量',
						zd: '英制',
						dw: 'oz/ft2',
						hsgs: '1oz/ft2=305.16g/m2'
					}
				],
				tableData2: [{
						sx: '基本重量/【kg/（mm.m2】',
						ff: '7.85kg(厚度1mm.面积1m2的重量)',
						jgxy: '-'
					},
					{
						sx: '单位重量/kg/m2',
						ff: '基本重量/【kg/(mm.m2)】X厚度(mm)',
						jgxy: '修约到有效数字4位'
					},
					{
						sx: '一张钢板的重量/kg',
						ff: '单位重量(kg/m2) X 面积(m2)',
						jgxy: '修约到有效数字3位'
					},
					{
						sx: '* 适用于冷轧无镀层、电镀锡及电镀铬等产品。',
						ff: '',
						jgxy: ''
					}
				],
				tableData3: [],
				tableData3_loading: false,
				currentPage4: 1,
				pageSizes: [10, 20, 30, 40],
				pageSize: 13,
				total: 0,
				activeName: 'first',
				ruleForm: {
					hd: 0,
					kd: 0,
					cd: 0,
					sl: 0
				},
				rules: {
					hd: [{
						required: true,
						message: '请输入厚度',
						trigger: 'blur'
					}],
					kd: [{
						required: true,
						message: '请输入宽度',
						trigger: 'blur'
					}],
					cd: [{
						required: true,
						message: '请输入长度',
						trigger: 'blur'
					}],
					sl: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}]
				},
				ruleForm1: {
					hd: 0,
					kd: 0,
					zl: 0,
					sl: 0,
					zldw: 'T'
				},
				rules1: {
					hd: [{
						required: true,
						message: '请输入厚度',
						trigger: 'blur'
					}],
					kd: [{
						required: true,
						message: '请输入宽度',
						trigger: 'blur'
					}],
					zl: [{
						required: true,
						message: '请输入重量',
						trigger: 'blur'
					}],
					sl: [{
						required: true,
						message: '请输入数量',
						trigger: 'blur'
					}]
				},
				formInline: {
					gs: '',
					kwd: ''
				},
				searchForm: {},
				isSearch: false,
				curPdf: {},
				pdfPrev: "https://www.liligc.com/pdfView/pdfjs/web/viewer.html?file=",
			};
		},
		mounted() {
			this.getPdfList();
		},
		methods: {
			submitForm(type) {
				if (type == 'ruleForm') {
					let a = this.ruleForm.hd;
					let b = this.ruleForm.cd;
					let c = this.ruleForm.kd;
					let d = this.ruleForm.sl;
					if (!a || !b || !c || !d) {
						alert("请填写正确的数据");
						return
					}
					let num = a * b * c * d * 7.85 / 1000000000;
					let kg = num * 1000;
					this.ruleForm.res = kg + "KG";
				} else {
					let a = this.ruleForm1.hd;
					let c = this.ruleForm1.kd;
					let d = this.ruleForm1.sl;
					let e = this.ruleForm1.zl;
					if (!a || !e || !c || !d) {
						alert("请填写正确的数据");
						return
					}
					if (this.ruleForm1.zldw == 'KG') {
						e = e / 1000;
					}
					let num = e * 1000000000 / (a * c * d * 7.85);
					this.ruleForm1.res = num.toFixed(4) + "mm";
				}
				this.$forceUpdate();
			},

			searchData(pageData) {
				if (!this.formInline.kwd && !this.formInline.gs) {
					this.$message.warning("请输入任意搜索值或选择归属");
					return;
				}
				this.isSearch = true;
				let page_data = {
					page_size: this.pageSize,
					current_page: 1,
				};
				if (pageData) {
					page_data = pageData;
				}
				let condition = {};
				if (this.formInline.kwd) {
					var reg = /.*[\u4e00-\u9fa5]+.*$/;
					if (reg.test(this.formInline.kwd)) {
						condition['bzm'] = {
							"value": this.formInline.kwd
						};
					} else {
						condition['bzh'] = {
							"value": this.formInline.kwd
						};
					}
				}

				if (this.formInline.gs) {
					condition['gs'] = {
						"value": this.formInline.gs
					};
				}

				this.getPdfList(page_data, condition);
			},
			resetSearch() {
				this.searchForm = {};
				this.formInline.kwd = "";
				this.formInline.gs = "";
				this.currentPage4 = 1;
				this.getPdfList();
				this.isSearch = false;
			},
			showPDF(row) {
				row.look++;
				this.lookCount(row.id);
				this.curPdf = row;
			},
			handleSizeChange(page_size) {
				this.pageSize = page_size;
				this.currentPage4 = 1;
				this.getPdfList();
			},
			handleCurrentChange(click_page) {
				this.currentPage4 = click_page;
				this.getPdfList();
			},
			lookCount(id) {
				let sendData = {
					lookId: id,
					serverType: 3
				};
				look_api_pdfInstruction(sendData);
			},
			async getPdfList(page_data, condition) {
				this.tableData3_loading = true;
				this.tableData3 = [];
				this.total = 0;
				let sendData = {
					pn: this.currentPage4,
					rn: this.pageSize,
					condition: {},
					serverType: 3
				};
				if (page_data) {
					sendData.pn = page_data.current_page;
					sendData.rn = page_data.page_size;
				}
				if (condition) {
					sendData.condition = Object.assign(sendData.condition, condition);
				}
				sendData.condition = JSON.stringify(sendData.condition);
				let res = await getList_api_pdfInstruction(sendData);
				res = res.data;
				if (res.success === true) {
					this.tableData3 = res.dataList.list;
					this.total = res.dataList.total;
					this.curPdf = this.tableData3[0];
				}else{
					this.curPdf = {};
				}
				this.tableData3_loading = false;
				this.$forceUpdate();
			},
		},
	};
</script>

<style lang="less" scoped>
	.myvideo {
		width: 400px;
		height: 316px;
		position: relative;

	}

	.video-box {
		padding: 0 0;
		position: relative;
	}

	.video-box img {
		margin-top: -60px;
	}

	.video-img-box video {
		position: absolute;
		width: 370px;
		top: -50px;
		left: 3.6%;
		background-color: #000000;
		padding-bottom: 4.1%;
	}

	.mtp {
		height: 494px;
		width: 1141px;
		margin: auto;
	}

	.right-box {
		position: relative;
		border: 1px solid #ededed;
		background-color: #fff;
		height: 1035px;
		padding: 10px;
		overflow-y: auto;
		overflow-x: hidden;
	}

	.right-item {
		text-align: left;
		margin-top: 20px;
		font-size: 15px;
	}

	.right-item .bzm {
		cursor: pointer;
		white-space: nowrap;
	}

	.pdfLogo {
		width: 20px;
		height: 20px;
		margin-right: 10px;
	}

	.right-item .bzm:hover {
		text-decoration: underline;
		text-underline-offset: 5px;
	}

	.bzm-active {
		color: #22ab82 !important;
	}

	.doc_header_mod {
		background-color: #fff;
		border: 1px solid #f2f3f4;
		border-radius: 4px;
		padding: 15px 0 15px 20px;
		-webkit-box-shadow: 0 0 12px 0 rgba(0, 0, 0, .01), 0 0 0 1px rgba(0, 0, 0, .01);
		box-shadow: 0 0 12px 0 rgba(0, 0, 0, .01), 0 0 0 1px rgba(0, 0, 0, .01);
		display: flex;
		flex-direction: column;
		align-items: flex-start;
		margin-bottom: 20px;
	}

	.title-box {
		margin: 10px 0;
	}

	.title-box .title-item {
		color: #7d7d7d;
		margin: 0 18px 0 -2px;
	}
</style>